import { Animated, Pressable, StyleSheet, View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { Ionicons } from "@expo/vector-icons";
import { useState } from "react";
import { Cube } from "../../../svgs/common";

const ModuleAccordion = ({ module, index }) => {
  const [expanded, setExpanded] = useState(false);
  const rotateAnim = useState(new Animated.Value(0))[0];

  const toggleAccordion = () => {
    setExpanded(!expanded);
    Animated.timing(rotateAnim, {
      toValue: expanded ? 0 : 1,
      duration: 200,
      useNativeDriver: true,
    }).start();
  };

  const rotateInterpolate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "180deg"],
  });

  return (
    <View style={styles.moduleContainer}>
      <Pressable onPress={toggleAccordion} style={styles.moduleHeader}>
        <View style={styles.headerLeftContent}>
          <CustomText
            text={module?.name}
            size="s"
            weight="ultraBold"
            useTranslationText={false}
            style={styles.moduleTitle}
          />
          <View style={styles.activitiesBadge}>
            <Cube />
            <CustomText
              text={`${module?.activities?.length} Activities`}
              size="s"
              weight="bold"
              useTranslationText={false}
              style={styles.badgeText}
            />
          </View>
        </View>
        <Animated.View style={{ transform: [{ rotate: rotateInterpolate }] }}>
          <Ionicons name="chevron-down" size={24} color="#667085" />
        </Animated.View>
      </Pressable>

      {expanded && (
        <View style={styles.moduleContent}>
          {module?.activities?.map((activity, index) => (
            <CustomText
              key={activity.id}
              text={activity.name}
              size="s"
              useTranslationText={false}
              style={index < module.activities.length - 1 ? { marginBottom: 8 } : null}
            />
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  moduleContainer: {
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#EAECF0",
    borderRadius: 16,
    overflow: "hidden",
  },
  moduleHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#FFFFFF",
  },
  headerLeftContent: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  moduleTitle: {
    color: "#101828",
    marginRight: 12,
  },
  activitiesBadge: {
    backgroundColor: "#F2F4F7",
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  badgeText: {
    color: "#667085",
  },
  moduleContent: {
    padding: 20,
    backgroundColor: "#FFFFFF",
  },
});

export default ModuleAccordion;
